import * as React from 'react';
import { useForm, FormProvider, } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';

interface HookForm extends React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> {
  defaultValues: any,
  schema: any,
  onSubmit: (values: any) => void;
}

const Form: React.FC<HookForm> = ({ defaultValues, schema, onSubmit, children, ...props }) => {
  const methods = useForm({
    mode: 'onBlur',
    defaultValues,
    resolver: schema && yupResolver(schema),
  });
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} noValidate {...props}>{children}</form>
    </FormProvider>
  )
}

export default Form;